const funcNav = (() => {



  let body = document.querySelector('body');
  let nav = document.getElementById('jsNav');
  let navBtn = document.getElementById('jsNavBtn');


  navBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (navBtn.classList.contains('act') == true) {
      body.classList.remove('hidden');
      nav.classList.remove('act');
      navBtn.classList.remove('act');
    } else {
      body.classList.add('hidden');
      nav.classList.add('act');
      navBtn.classList.add('act');
    }
  });



  // ScrollTrigger.create({
  //   trigger: 'body',
  //   start: '10px 0%',
  //   end: '100% 0%',
  //   toggleClass: { targets: "#jsNavFloat", className: "act" },
  //   // markers: true,
  // });



})();
export default funcNav;